import { Controller } from 'stimulus';
import { updateDropdownMenuPositionInExtendedFilters } from "../packs/filter_helpers";

export default class extends Controller {
  static targets = ['template', "forms"];

  initialize() {
    if(window.location.pathname.includes("/manage_attributes")){
      let attribute_key_count = $(".key-form").length
      if(attribute_key_count == 0){
        var content = this.templateTarget.innerHTML.replace(/new_record/g, attribute_key_count + 1);
        $(this.formsTarget).append(content)
      }
    }
  }

  addKeyFilter(event) {
    if (event.target.checked) {
      let url = `/projects/add_key_filter?`
      let params = new URLSearchParams()
      let key_id = event.target.dataset.id;
      let filter_type = event.target.dataset.type;
      params.set("key_id", key_id);
      params.set("filter_type", filter_type);

      let class_name = '.' + event.target.dataset.type + '-' + event.target.dataset.id;
      let container = $(`#${event.target.dataset.type}_dynamic_filters`)

      Rails.ajax({
        type: 'GET',
        url: url + params,
        dataType: 'json',
        success: (response) => {
          container.append(response)
          updateDropdownMenuPositionInExtendedFilters();
        }
      })
    } else {

// TODO: integrate these updates into the code properly
//      let class_name = '.' + event.target.dataset.type + '-' + event.target.dataset.id;
//      $(class_name).find('input[type=checkbox]:checked').removeAttr('checked');
//      this.searchKeyFilter();
//      $(class_name).remove();

      let removeElement = '.' + event.target.dataset.type + '-' + event.target.dataset.id
      var reload = false;
      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);
      let param_name = `${event.target.dataset.type}[${event.target.dataset.id}]`

      if(event.target.dataset.dataType == "date" || event.target.dataset.dataType == "number"){
        if(params.get(`${param_name}[from]`) || params.get(`${param_name}[to]`)) reload = true;
        params.delete(`${param_name}[from]`)
        params.delete(`${param_name}[to]`)
      } else {
        if(params.get(`${param_name}`)) reload = true;
        params.delete(`${param_name}`)
      }

      if(reload) window.location.href = window.location.href.split('?')[0] + '?' + params.toString()
      $(removeElement).remove();

    }
  }

  searchKeyAttributes(event) {
    var search = $(event.target).val().trim().toLowerCase();
    $(".dynamic-add-checkbox").each(function () {
      if ($(this).text().toLowerCase().indexOf(search) < 0){
        $(this).hide()
      } else {
        $(this).show()
        $(this).children('ul')?.first()?.addClass('show')
      }
    })
  }

  renderNewKeyForm(event) {
    event.preventDefault();
    
    let current_max_position = $(".key-form").length
    let next_positon = Number(current_max_position) + 1

    var content = this.templateTarget.innerHTML.replace(/new_record/g, next_positon);
    $(this.formsTarget).append(content)
  }

  removeAttributeKeyField(event) {
    let attribute_key_id = $(event.target).parents(".remove-button-container").data("key-id");

    if(attribute_key_id){
      Rails.ajax({
        type: 'GET',
        url: `/attribute_keys/${attribute_key_id}/has_attribute_values`,
        dataType: 'json',
        success: (response) => {
          if(response.has_values){
            if (confirm('This key has associated values, if you delete the key all the associated data will be lost.')){
              $(event.target).parents(".key-form").find(".destroy-field").val("1")
              $(event.target).parents(".key-form").hide();
            }
          } else {
            $(event.target).parents(".key-form").find(".destroy-field").val("1")
            $(event.target).parents(".key-form").hide();
          }
        }
      })
    } else {
      $(event.target).parents(".key-form").find(".destroy-field").val("1")
      $(event.target).parents(".key-form").hide();
    }
    
  }
}